import React from "react";
import { Container, Box, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

const ImprintPage = () => {
  const { t } = useTranslation();

  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: 900,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom>
          {t("legalImprint.title")}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          {t("legalImprint.legalNotice")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 2 }}>
          {t("legalImprint.company")}
        </Typography>
        <Typography>{t("legalImprint.addressLine1")}</Typography>
        <Typography>{t("legalImprint.addressLine2")}</Typography>

        <Typography sx={{ mt: 2 }}>{t("legalImprint.registry")}</Typography>
        <Typography>{t("legalImprint.court")}</Typography>

        <Typography variant="h6" sx={{ mt: 3 }}>
          {t("legalImprint.representedByLabel")}
        </Typography>
        <Typography>{t("legalImprint.representedBy")}</Typography>

        <Typography variant="h6" sx={{ mt: 3 }}>
          {t("legalImprint.contactLabel")}
        </Typography>
        <Typography>
          {t("legalImprint.phoneLabel")}:{" "}
          <Link href={`tel:${t("legalImprint.phoneValue")}`} underline="hover">
            {t("legalImprint.phoneValue")}
          </Link>
        </Typography>
        <Typography>
          {t("legalImprint.emailLabel")}:{" "}
          <Link
            href={`mailto:${t("legalImprint.emailValue")}`}
            underline="hover"
          >
            {t("legalImprint.emailValue")}
          </Link>
        </Typography>
      </Box>
    </Container>
  );
};

export default ImprintPage;
